import {observer} from "mobx-react";
import * as React from "react";
import Dropzone from "react-dropzone";
import Icon from "../Icon/Icon";

interface ILocalState {}
interface IProps {
    propertyName: string
    acceptedFiles: string
    onFileUpload: (files: any) => void;
}

@observer
export default class FileInputUploadFailure extends React.Component<IProps> {
    public state: ILocalState = {};

    public render() {
        const {propertyName, acceptedFiles, onFileUpload} = this.props;
        if(propertyName === "idImage") {
            return (<div className="files-container">
                This file couldn't be verified,<br/> but keep going! We'll sort it out later.
            </div>)
        }else {
            return (<Dropzone onDrop={onFileUpload}  accept={acceptedFiles}>
                {({getRootProps, getInputProps}) => (
                    <section>
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="files-container">
                                <Icon icon={'error'}/>
                                <div>Something went wrong...</div>
                                <div className="try-again-btn">Try again</div>
                            </div>
                        </div>
                    </section>
                )}
            </Dropzone>)
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/FormFileInput/FileInputUploadFailure.tsx